module.exports = __webpack_public_path__ + "img/773.f8660533.png";